import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È cartaceo o digitale?',
  a: 'È un prodotto 100% digitale in formato PDF ad alta risoluzione, ottimizzato per laptop, tablet, smartphone e iPad.'
}, {
  q: 'È adatto a insegnanti principianti?',
  a: 'Sì. Il sistema è progettato sia per insegnanti alle prime armi che per professionisti con esperienza.'
}, {
  q: 'Posso usarlo con allievi individuali e con gruppi?',
  a: 'Assolutamente. I programmi e i template funzionano sia per sessioni individuali che per lezioni di gruppo.'
}, {
  q: 'Include sequenze per diversi livelli di yoga?',
  a: 'Sì. Il sistema include framework per principianti, livello intermedio, yoga terapeutico, yoga espressivo e programmi di trasformazione corporea.'
}, {
  q: 'Quanto velocemente vedrò i risultati?',
  a: 'La maggior parte degli insegnanti riferisce di risparmiare diverse ore di pianificazione già nella prima settimana di utilizzo.'
}, {
  q: 'Posso stampare i manuali e i planner?',
  a: 'Certamente. Tutti i PDF sono formattati per essere facilmente stampati a casa o in copisteria, perfetti per essere portati in studio.'
}, {
  q: 'È un abbonamento mensile?',
  a: 'No, è un pagamento unico. Paghi una sola volta e hai accesso a vita a tutto il sistema YOGA PRO™ e ai 5 bonus premium.'
}, {
  q: 'I bonus sono inclusi nel prezzo di €27?',
  a: 'Sì, tutti e 5 i bonus premium (Kit Adattamenti, Banca Intro/Chiusure, Planner, Checklist, Matrice) sono inclusi gratuitamente se acquisti oggi.'
}, {
  q: 'Cosa succede se non mi trovo bene con il sistema?',
  a: "Hai una garanzia di 7 giorni. Se il sistema non soddisfa le tue aspettative, inviaci un'email e ti rimborseremo il 100% dell'importo, senza fare domande."
}, {
  q: "Come riceverò il materiale dopo l'acquisto?",
  a: "Subito dopo il pagamento sicuro, riceverai un'email con il link per scaricare immediatamente l'intero Box Set e tutti i bonus sul tuo dispositivo."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-brand-light border-b-8 border-brand-green" data-id="element-41">
      <div className="max-w-4xl mx-auto" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-dark mb-4 tracking-tight uppercase" data-id="element-44">
            DOMANDE FREQUENTI
          </h2>
        </div>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, i) => <div key={i} className="bg-white border-2 border-brand-green/20 rounded-xl overflow-hidden transition-all duration-200 hover:border-brand-green shadow-md" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center gap-4" data-id="element-47">
                <span className="font-black text-brand-dark text-base sm:text-lg leading-snug uppercase" data-id="element-48">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-brand-green transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              {openIndex === i && <div className="px-6 pb-5 pt-0 text-brand-dark/80 font-medium text-base leading-relaxed" data-id="element-50">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}